// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1_ssV","cls2":"NewsInteractionBar-cls2_f7V NewsInteractionBar-cls1_ssV"};